module.exports = __webpack_public_path__ + "static/media/CONTRATO PROFECO 3 servicios 270-2020.3f1e3416.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/CONTRATO PROFECO 3 servicios 270-2020.pdf
// module id = 354
// module chunks = 0